import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getUsers = async () => {
  // const response = await axios.get(`${base_url}user/all`);
  const response = await axios.get(`${base_url}user/all`, getAuthHeaders());

  return response.data;
};

const customerService = {
  getUsers,
};

export default customerService;
